import { IDHFControlDefinition } from "../../../../common/businesslogic";
import { ml } from "../../../../common/matrixlib";
import { IBaseControlOptions } from "../../../../common/UI/Controls/BaseControl";
import { ISingleDefaultControllerConfig, SingleSelectBase } from "../../../../SingleSelectBase";
import { ILinkListOptions } from "../../../../common/businesslogic/FieldHandlers/Document/LinkListDocFieldHandler";
export { LinkList };

class LinkList extends SingleSelectBase<ILinkListOptions> {
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    renderControl(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions) {
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        ctrl.control.itemSelection(
            ml.JSON.mergeOptions(ctrlParameter, {
                parameter: {
                    prefix: "Include references of these items",
                    buttonName: "Select Items",
                    showOnly: [],
                    showNot: ["REPORT"],
                },
            }),
        );
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    showSpecificSettings(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {
        let controllerConfig = this.getConfig(ctrl);

        let external_links = $(
            '<select class="docOptionSelect p0 form-control" style="">' +
                '<option value="0">Show items without external links</option>' +
                '<option value="1">Show external links</option>' +
                '<option value="2">Show only done external links</option>' +
                '<option value="3">Show only external links which need to be done</option>' +
                "</select>",
        );

        let options =
            '<div class="checkbox" ><label><input type="checkbox" class="includeInToc" ' +
            (controllerConfig.includeInToc ? "checked" : "") +
            "> Add a reference to included items to table of content</label></div>";
        custom.append($(options));

        custom.append(external_links);

        $(custom.find(".p0")[0]).val(controllerConfig.showExternal);

        this.addSpecificSettings(controllerConfig, custom);
    }
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async saveSpecificSettingsAsync(ctrl: IDHFControlDefinition, ctrlParameter: IBaseControlOptions, custom: JQuery) {
        let controllerConfig = this.getConfig(ctrl);

        let showExternal = $(custom.find(".p0")[0]).val();

        let changed = showExternal !== controllerConfig.showExternal;
        controllerConfig.showExternal = showExternal;

        changed = changed || controllerConfig.includeInToc !== $(custom.find(".includeInToc")[0]).prop("checked");
        controllerConfig.includeInToc = $(custom.find(".includeInToc")[0]).prop("checked");

        let specificChanged = this.setSpecificSettings(controllerConfig, custom);

        this.fieldHandler.setDHFConfig(controllerConfig);

        return changed || specificChanged;
    }

    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    protected config: ISingleDefaultControllerConfig;
}
